import React from "react";
import "./CertificateSection.css";
import CertificateImg from "./Certificate.webp"; // Change filename if needed
import {
  FaAward,
  FaCheckCircle,
  FaLinkedin,
  FaBriefcase,
} from "react-icons/fa";

const CertificateSection = () => {
  return (
    <section className="certificate">

      <div className="certificate-content">

        {/* Left Side */}

        <div className="certificate-left">

          <div className="certificate-badge">
            <FaAward />
            <span>Industry Recognized Certificate</span>
          </div>

          <h2>
            Earn Your <span>Professional Certificate</span>
          </h2>

          <p>
            Successfully complete your training, build real-world projects,
            and receive an industry-ready certificate that strengthens your
            resume and showcases your practical skills.
          </p>

          <div className="certificate-features">

            <div>
              <FaCheckCircle />
              Resume Ready
            </div>

            <div>
              <FaLinkedin />
              LinkedIn Shareable
            </div>

            <div>
              <FaBriefcase />
              Industry Recognized
            </div>

            <div>
              <FaCheckCircle />
              Project Based Certification
            </div>

          </div>

        
        </div>

        {/* Right Side */}

        <div className="certificate-right">

          <img
            src={CertificateImg}
            alt="PRT Academy IT course completion certificate"
          />

        </div>

      </div>

    </section>
  );
};

export default CertificateSection;